import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

type Props = {
  isHowLink?: boolean;
};

export const SectionTitleTemplate = ({isHowLink = true}: Props) => (
  <Grid
    container
    size={12}
    mb={'4px'}
    display={'flex'}
    justifyContent={'space-between'}
    sx={{
      position: 'relative',
      overflow: 'hidden',
    }}>
    <Grid size={4}>
      <Skeleton variant="text" width="100%" height="20px" />
    </Grid>
    {isHowLink && (
      <Grid size={1}>
        <Skeleton variant="text" width="100%" height="20px" />
      </Grid>
    )}
  </Grid>
);
